// extracted by mini-css-extract-plugin
module.exports = {"w1090":"w1090-3a9aN0Zj"};